import { Injectable, inject } from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';
import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class TrackingTypeService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private trackingTypeUrl = this.baseApiUrl + '/api/v1/tracking_type';

  getAll(params: any = {}) {
    return this.http.get(`${this.trackingTypeUrl}`, {params});
  }

  updateTrackingStatus(projectId: number, trackingType: any) {
    return this.http.put(`${this.trackingTypeUrl}/${projectId}`, { trackingType });
  }
}
